<template>
  <div>
    <div class="fav-card" v-for="(fav, idx) in favs" :key="idx">
      <div>
        <img :src="fav.image" alt="Imagen" @click="openDetail(fav)" style="cursor: pointer;">
        <div style="display: flex; flex-direction: column; align-items: flex-start; padding-left: 10px; width: 100%">
          <div @click="openDetail(fav)" style="cursor: pointer;">
            <p style="font-weight: bold; font-size: .7rem">{{ fav.brand }}{{ fav.model }}, {{ fav.year }}, {{ fav.version }}</p>
            <div style="background: #000; border-radius: 5px; padding: 3px 5px; color: #fff; display: flex; align-items: center; font-weight: bold">
                En {{ fav.dealer }} &bull; {{ fav.state }}
                <img src="/images/location-pin.png" alt="" style="width: 7px; margin: 0 10px">
            </div>
            <h2 style=" font-weight: bold; font-size: 1.5rem; margin: 10px 0 0 0">{{currencyFormat.format(fav.price)}} mxn</h2>
            <small style="color: gray; font-size: .8rem">{{ fav.kilometers.toLocaleString() }} km | </small>
          </div>
            <div class="content__car__detail" style="display: flex; justify-content: space-between; width: 100%; padding-top: 20px; align-items: center">
                <whatsapp-button-component style="width: 200px"
                    :user_id="user_id"
                    :user_name="user_name"
                    :user_phone="user_phone"
                    :product="getProducObject(fav)"
                    :cellphone="fav.cellphone"
                    :message="fav.wame_message"
                >
                </whatsapp-button-component>
                <!-- <button v-if="fav.mkt_vehicle_id" :href="`/anuncio/${fav.mkt_vehicle_id}/`" style="background: rgb(219, 254, 84); border-radius: 5px; border: none; font-weight: bold; padding: 8px 16px;"
                @click="wame(fav)">Mandar whatsapp</button>
                <button v-if="fav.mkt_brand_new_vehicle_id" :href="`/nuevos/anuncio/${fav.mkt_brand_new_vehicle_id}/`" style="background: rgb(219, 254, 84); border-radius: 5px; border: none; font-weight: bold; padding: 8px 16px;"
                @click="wame(fav)">Mandar whatsapp</button>-->
                <img src="/images/trash-can.png" alt="" style="width: 15px; cursor: pointer" @click="deleteFav(fav)">
                <!-- <img v-if="fav.mkt_brand_new_vehicle_id" src="/images/trash-can.png" alt="" style="width: 15px; cursor: pointer" @click="deleteFav(fav)"> -->
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { forEach } from 'lodash';
import WhatsappButtonComponent from '../front/layout/WhatsappButtonComponent.vue';

export default {
    props: ["cellphone", "product", "user_id", "message", "btn-text", "user_name", "user_phone"],
  data() {
    return {
      favs: [],
      currencyFormat: Intl.NumberFormat('es-MX', {style: 'currency', currency: 'MXN'}),
    }
  },
  components: {
        'whatsapp-button-component': WhatsappButtonComponent
    },
  created() {
    this.getProfFavs()
    // this.getFavs()

/*     document.getElementById('mobile_menu_toggle').addEventListener('click', function(e) {
        e.target.classList.toggle('mobile-menu-toggle-visible')
    })

    document.getElementById('mobile_menu_toggle').addEventListener('click', function(e) {
      e.target.classList.toggle('mobile-menu-toggle-visible')
      document.getElementById('mobile_nav_menu_content').classList.toggle('mobile-nav-menu-visible')
    }) */
  },
  methods: {
    async getFavs() {
        const storageFavs = JSON.parse(localStorage.getItem('likes'))

        try {
          const { data } = await axios.post('/favoritos', storageFavs)
          this.favs = data

          const storageLikes = []
            for(let i = 0; i < 2; i++) {
                if(this.favs[i]) {
                if(this.favs[i].mkt_vehicle_id)
                storageLikes.push({
                    mkt_vehicle_id: this.favs[i].mkt_vehicle_id
                })
                else
                    storageLikes.push({
                    mkt_brand_new_vehicle_id: this.favs[i].mkt_brand_new_vehicle_id
                    })
                }
            }
            localStorage.setItem('likes', JSON.stringify(storageLikes))
        } catch (error) {
          console.error(error)
        }
      },
    async getProfFavs() {

      const likes = JSON.parse(localStorage.getItem('likes'))
      const url = '/favorites'

      const {data} = await axios.post(url, likes)
      this.favs = data

    },
    async deleteFav(fav) {
      await axios.put('/delete-favorite', fav)
      const likes = JSON.parse(localStorage.getItem('likes'))

      let idx = -1
      if(fav.mkt_vehicle_id) {
        idx = likes.indexOf(e => e.mkt_vehicle_id == fav.mkt_vehicle_id)
      }
      if(fav.mkt_brand_new_vehicle_id) {
        idx = likes.indexOf(e => e.mkt_brand_new_vehicle_id == fav.mkt_brand_new_vehicle_id)
      }
      likes.splice(idx, 1)
      localStorage.setItem('likes', JSON.stringify(likes))

      window.location.reload()
    },
    openWhatsapp (url) {
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
    },
    wame(fav) {
      const cellphone = fav.cellphone.replaceAll('-', '')
      this.openWhatsapp(`https://wa.me/${cellphone}?text=${fav.wame_message}`)
    },
    openDetail(fav) {
      if(fav.mkt_vehicle_id)
        location.href = `/anuncio/${fav.mkt_vehicle_id}`
      else
      location.href = `/nuevos/anuncio/${fav.mkt_brand_new_vehicle_id}`
    },
    getProducObject (item) {
        let product = {
        id: item.mkt_vehicle_id || item.mkt_brand_new_vehicle_id,
        brand: { title: item.brand },
        model: { title: item.model},
        year: item.year
        }
        return product
    }
  }
}
</script>
<style scoped>
.fav-card {
	display: flex;
	align-items: flex-start;
	border-bottom: 1px solid lightgray;
}

.fav-card > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  font-size: .8rem;
  width: 580px;
}
.fav-card > div > img {
  width: 470px;
  height: 161px;
  object-fit: cover;
}


@media only screen and (min-width: 490px) {
  .fav-card > div {
    flex-direction: row;
  }
  .fav-card > div > img {
    height: 161px;
    width: 470px;
  }
}

</style>
